
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.57.82L16.5 5v1.68H.68V5L8.57.82zm3.75 7.5h2.5v5.86h-2.5V8.32zm-11.64 10v-2.5H16.5v2.5H.68zm6.64-10h2.5v5.86h-2.5V8.32zm-5 0h2.5v5.86h-2.5V8.32z","fill":"currentColor"}})])
          )
        }
      }
    